// Breakpoints only change on resize. Reading window.innerWidth right after the
// width-class writes in initCarousel()/adjustToViewport() forced a synchronous
// layout per carousel on page load, so every carousel reads this cached value.
// The resize event fires before ResizeObserver callbacks in the same frame.
let viewportWidth = window.innerWidth;
window.addEventListener('resize', () => {
    viewportWidth = window.innerWidth;
}, { passive: true });

function carousel(config) {

    let self = {
        offset: 0,
        products: [],  // Will be populated in initCarousel
        showButtons: false,
        startX: 0,   // Starting touch position
        moveX: 0,   // Touch position during move
        isDragging: false,
        initialOffset: 0,
        endX: 0,    // Ending X coordinate when touch ends
        totalSlides: 0,
        currentPosition: 0,

        // Initialize the carousel based on viewport
        initCarousel() {
            // Query products within THIS carousel only
            this.products = this.$refs.carouselWrapper ?
                Array.from(this.$refs.carouselWrapper.querySelectorAll('.product-item')) :
                [];

            let itemsPerView = this.getItemsPerView();
            this.totalSlides = this.products.length;

            // Here's how we can utilize itemsPerView:
            this.offset = 0;

            if (itemsPerView !== this.getItemsPerView()) {
                this.adjustToViewport(); // Adjust the carousel based on the new viewport size
            }

            if (this.totalSlides <= this.getItemsPerView()) {
                this.offset = 0;
            }

            // Apply the correct classes based on the viewport
            this.products.forEach(product => {
                product.className = 'product-item p-1 sm:p-2 items-stretch flex';  // remove all possible width classes
                product.classList.add(this.computedWidthClass);  // add the correct width class
            });

            // Initialize the ResizeObserver
            this.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    this.adjustToViewport();
                }
            });

            // Start observing the current carousel element (wrapper)
            this.resizeObserver.observe(this.$el);
        },

        canMoveToPrev() {
            return this.offset > 0;
        },
        canMoveToNext() {
            return this.offset < this.getMaxOffset();
        },

        // Slide to the previous set of products
        prevSlide() {
            if (this.offset > 0) {
                this.offset--;
                this.$refs.carouselWrapper.style.transform = `translateX(-${this.offset * 100}%)`;
            }
        },

        // Slide to the next set of products
        nextSlide() {
            let maxOffset = this.getMaxOffset();

            if (this.offset < maxOffset) {
                this.offset++;
            }
        },



        // Determine the maximum offset based on the current breakpoint
        getMaxOffset() {
            let itemsPerView = this.getItemsPerView();
            return Math.ceil(this.products.length / itemsPerView) - 1;
        },

        // Determine the number of items to show based on the current breakpoint
        getItemsPerView() {
            let width = viewportWidth;

            if (width < 640) return config.xs; // xs
            else if (width < 768) return config.sm; // sm
            else if (width < 1024) return config.md; // md
            else if (width < 1280) return config.lg; // lg
            else return config.xl; // xl
        },

        touchStart(event) {
            this.isDragging = true;
            this.startX = event.touches[0].clientX;   // Record starting X coordinate
        },

        touchMove(event) {
            if (this.isDragging) {
                this.moveX = event.touches[0].clientX;
            }
        },

        touchEnd() {
            this.isDragging = false;
            this.endX = this.moveX;   // Record ending X coordinate

            let diff = this.startX - this.endX;   // Calculate swipe difference

            // If swipe difference exceeds a threshold of 50 pixels
            if (diff > 50 && this.offset < this.getMaxOffset()) {
                this.offset++;
            } else if (diff < -50 && this.offset > 0) {
                this.offset--;
            }
        },

        // Adjust the carousel based on the viewport size
        adjustToViewport() {
            let itemsPerView = this.getItemsPerView();

            let currentFirstItemIndex = this.offset * itemsPerView;

            // Determine which slide (or offset) the previous first item should now be in
            let newOffset = Math.floor(currentFirstItemIndex / itemsPerView);

            // If the current items would exceed the total products, adjust to the last possible slide
            while ((newOffset * itemsPerView + itemsPerView) > this.products.length) {
                newOffset--;
            }

            if (this.totalSlides <= this.getItemsPerView()) {
                this.offset = 0;
            } else {
                this.offset = newOffset;
            }


            // Update the width of each product item based on the viewport
            this.products.forEach(product => {
                product.className = 'product-item p-1 sm:p-2 items-stretch flex';
                product.classList.add(this.computedWidthClass);
            });

            if (this.totalSlides > this.getItemsPerView()) {
                this.$refs.carouselWrapper.style.transform = `translateX(-${this.offset * 100}%)`;
            }

        },

        // Computed property to return the correct width class based on items per view
        get computedWidthClass() {
            let itemsPerView = this.getItemsPerView();
            switch (itemsPerView) {
                case 1: return 'min-w-full';
                case 2: return 'min-w-1/2';
                case 3: return 'min-w-1/3';
                case 4: return 'min-w-1/4';
                case 5: return 'min-w-1/5';
                default: return 'min-w-full';
            }
        },
    };

    return self;
}

window.carousel = carousel;